import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LuLogOut, LuUser, LuMenu } from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';

const Header = ({ toggleSidebar }) => {
  const { userProfile, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      const { error } = await signOut();
      if (error) {
        console.error('Logout error:', error.message);
      } else {
        // Navigate to login page after successful logout
        navigate('/login');
      }
    } catch (err) {
      console.error('Unexpected logout error:', err);
    }
  };

  return (
    <div className="bg-white shadow-sm border-gray-200 border-b">
      <div className="ml-0 md:ml-64 px-4 sm:px-6 lg:px-8 transition-all duration-300">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <button
              type="button"
              className="md:hidden mr-4 focus:outline-none text-gray-500 hover:text-gray-700"
              onClick={toggleSidebar}
            >
              <span className="sr-only">Open sidebar</span>
              <SafeIcon icon={LuMenu} className="w-6 h-6" />
            </button>
            <h1 className="font-semibold text-gray-900 text-xl"> CRM Dashboard </h1>
          </div>
          <div className="flex items-center space-x-4">
            {userProfile && (
              <div className="flex items-center space-x-3">
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={LuUser} className="w-5 h-5 text-gray-400" />
                  <div className="text-sm">
                    <div className="font-medium text-gray-900">
                      {userProfile.full_name}
                    </div>
                    <div className="text-gray-500">
                      {userProfile.role} • {userProfile.teams?.name}
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleSignOut}
                  className="flex items-center space-x-1 hover:bg-gray-100 px-2 py-1 rounded-md text-gray-500 hover:text-gray-700 text-sm transition-all"
                  title="Sign out"
                >
                  <SafeIcon icon={LuLogOut} className="w-4 h-4" />
                  <span>Sign out</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;